import { PortfoliosWrapper } from "./portfolios-wrapper";

export default function PortfoliosPage() {
  return <PortfoliosWrapper />;
}
